export default {
  list: {
    title: "Liste des marchands",
    addStore: "Ajouter un marchand",
    storeName: "Marchand",
  },
  recharge: {
    title: "Recharge marchands",
    amount: "Montant",
    orderNo: "N° commande",
    rechargeTime: "Date",
    currentBalance: "Solde actuel",
  },
  pricing: {
    title: "Tarification",
    deliveryFee: "Frais de livraison",
    fixedAmount: "Montant fixe",
  },
  detail: {
    title: "Détail marchand",
    balance: "Solde",
    points: "Points",
    linkedShop: "Magasin lié",
    bindChannel: "Canal lié",
    storeName: "Marchand",
    storeNamePh: "Saisir le nom du marchand",
    regTime: "Date d'inscription",
    merchantNo: "N° marchand",
    contact: "Contact",
    contactPh: "Saisir le contact",
    tel: "Téléphone",
    telPh: "Saisir le téléphone",
    license: "Licence",
    address: "Adresse",
    addressPh: "Saisir l'adresse",
    orderStats: "Statistiques commandes",
    totalOrders: "Commandes totales",
    totalDeliveryFee: "Frais livraison totaux",
    totalRecharge: "Recharge totale",
    cancelComplaint: "Annulation / réclamation",
  },
};
